import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "form", "title", "info", "confirmBtn", "navbarSpacing", "preloadCheckInCard",
                    "optInEvent", "nameInput", "phone", "errorEmailCode", "email", "mainFrame", "formCard",
                    "midiaFrame", "questionFrame", "setAnswer", "footerFrame", "checkboxAcademic", "checkboxDoctor",
                    "graduationDropdown", "graduationDropdownBtn", "graduationInput", "graduationList", "graduation",
                    "checkboxNotDoctor", "academicRow", "doctorRow", "crmInput", "school", "liveBtn", "subtitle",
                    "crmStateInput"]


  connect() {
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.cardLoader = this.getControllerByIdentifier("app--helpers--loaders").cardLoader()
    this.controllerName = `mobile--commercial--marketing--events--attendees--enrollment`
    this.application.event_token = location.pathname.split("/").pop()
    this.application.current_visitor_token = this.getControllerByIdentifier("app--shared--cookies").getCookie("ahoy_visitor")
    this.first_interaction = true
    this.searchArray = []
    if (window.location.search.split("?")[1]) {
      this.searchArray = window.location.search.split("?")[1].split("&")
    }
    this.setNavbarSpacing()
    // window.onbeforeunload = function () {
    //   return "Do you really want to close?";
    // }
  }

  doPagePreload() {
    var html = `<div class="row mb-4">
                  <div class="col-12 text-center">
                    <img class="card-img-top live-img my-0" src="https://medcapital-site-main.s3-sa-east-1.amazonaws.com/MedSchool-Azul.png" alt="MedSchool" style="width:15rem;">
                  </div>
                </div>
                <div class="row w-100 my-3" data-${this.controllerName}-target="title">
                  <div class="col-12 text-center">
                    <h1 class="display-4 s-title-053B5E s-title-bold s-title-2rem text-center mb-4">
                      ${this.loader}
                    </h1>
                  </div>
                  <div class="col-12 text-center">
                    <p class="s-title-6F706F s-title-500 s-title-1rem mb-4">
                      ${this.loader}
                    </p>
                  </div>
                </div>
                <div class="row w-100 my-5 py-5">
                  <div class="col-12 d-flex align-items-center justify-content-center" data-${this.controllerName}-target="form">
                    <div class="card card-live w-100" data-step="0" data-${this.controllerName}-target="preloadCheckInCard">
                      <div class="card-body d-flex align-items-center justify-content-center">
                        <div class="row w-100">
                          <div class="col-12 my-4 text-center px-0">
                            ${this.loader}
                            ${this.loader}
                          </div>
                          <div class="col-12 my-4 px-0">
                            ${this.loader}
                            ${this.loader}
                          </div>
                          <div class="col-12 d-flex align-items-center justify-content-center mt-5 my-3">
                            ${this.loader}
                            ${this.loader}
                            <div class="card pointer w-100 bg-primary d-none">
                              ${this.loader}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row w-100 mt-5 pt-5 mb-3 pb-3" data-${this.controllerName}-target="subtitle">
                  <div class="col-12 text-center">
                    <h1 class="display-4 s-title-053B5E s-title-bold s-title-2rem text-center mb-4">
                      ${this.loader}
                    </h1>
                  </div>
                  <div class="col-12 text-center">
                    <p class="s-title-6F706F s-title-500 s-title-1rem mb-4">
                      ${this.loader}
                    </p>
                  </div>
                </div>
                <div class="row w-100 my-3 py-3" data-${this.controllerName}-target="midiaFrame">
                </div>
                <div class="row w-100 my-5 py-5" data-${this.controllerName}-target="questionFrame">
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.preloadCheckInCardTarget.style.height = ($(window).height() * 0.5) + "px"
    })
  }

  doTitleHtml() {
    var html = `<div class="col-12 text-center">
                  <h1 class="display-4 s-title-053B5E s-title-bold s-title-2rem text-center mb-4">
                    ${this.application.event.frame_one}
                  </h1>
                </div>
                <div class="col-12 text-center">
                  <p class="s-title-6F706F s-title-500 s-title-1rem mb-4">
                    ${this.application.event.subframe_one}
                  </p>
                </div>` 

    this.titleTarget.innerHTML = html
  }

  doSubtitleHtml() {
    var html = `<div class="col-12 text-center">
                  <h1 class="display-4 s-title-053B5E s-title-bold s-title-2rem text-center mb-4">
                    ${this.application.event.frame_two}
                  </h1>
                </div>
                <div class="col-12 text-center">
                  <p class="s-title-6F706F s-title-500 s-title-1rem mb-4">
                    ${this.application.event.subframe_two}
                  </p>
                </div>`

    this.subtitleTarget.innerHTML = html
  }

  doMidiaHtml() {

    if (this.application.event.midia == `video`) {
      var midia = `<div class="embed-responsive embed-responsive-16by9">
                    <iframe id="video" class="embed-responsive-item" src="https://www.youtube.com/embed/${this.application.event.video_link}" allowfullscreen></iframe>
                  </div>`
    } else if (this.application.event.midia == `cover`) {
      var midia = `<img src="${this.application.event.cover_url}" alt="${this.application.event.title}" class="imagem-head w-100" style="width:25rem">`
    }

    var html = `<div class="col-12">
                  ${midia}
                </div>`

    this.midiaFrameTarget.innerHTML = html
  }

  doQuestionsForm() {
    var html = `<div class="col-sm-12 mb-4">
                  <h1 class="display-4 title-two text-center">
                    Perguntas <span style="color:#26C485;"> Frequentes</span>
                  </h1>
                </div>
                <div class="col-sm-8 offset-sm-2">
                  <div class="accordion" id="accordionLanding">
                    <div class="card" style="z-index:20;">
                      <div class="card-header" id="headingOne">
                        <h5 class="mb-0">
                          <button id="questionOne" class="btn btn-link btn-wrap question" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            ${this.application.event.question_one}
                          </button>
                        </h5>
                      </div>
                      <div id="collapseOne" class="collapse " aria-labelledby="headingOne" data-parent="#accordionLanding">
                        <div class="card-body answer">
                          <span id="answerOne">${this.application.event.answer_one}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card" style="z-index:20;">
                      <div class="card-header" id="headingTwo">
                        <h5 class="mb-0 " >
                          <button id="questionTwo" class="btn btn-link btn-wrap collapsed question" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            ${this.application.event.question_two}
                          </button>
                        </h5>
                      </div>
                      <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionLanding">
                        <div class="card-body answer">
                          <span id="answerTwo">${this.application.event.answer_two}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card" style="z-index:20;">
                      <div class="card-header" id="headingThree">
                        <h5 class="mb-0">
                          <button id="questionThree" class="btn btn-link btn-wrap collapsed question" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            ${this.application.event.question_three}
                          </button>
                        </h5>
                      </div>
                      <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionLanding">
                        <div class="card-body answer">
                          <span id="answerThree">${this.application.event.answer_three}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`

    this.questionFrameTarget.innerHTML = html
  }

  doFormHtml() {

    var html = `<div class="card card-lp-bg-primary lp-card mt-6r" data-${this.controllerName}-target="formCard">
                  <div class="card-body d-flex align-items-center justify-content-center">
                    <div class="row">
                      <div class="col-12 my-4 text-center px-0">
                        <h2 class="lp-card-title">Confirme a sua inscrição:</h2>
                        <p class="d-none" data-${this.controllerName}-target="liveBtn">Se já se inscreveu, <span class="badge badge-secondary-primary pointer" data-action="click->${this.controllerName}#goToLive">clique aqui</span> para ir ao Evento.</p>
                      </div>

                      <div class="col-12 my-2">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="text" class="form-no-border lp-input-form" placeholder="Nome" required data-${this.controllerName}-target="nameInput" data-field="name" data-action="blur->${this.controllerName}#saveInteraction">
                            <span class="material-icons lp-input-icon">account_circle</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 my-2">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="mail" class="form-no-border lp-input-form" placeholder="E-mail" required data-${this.controllerName}-target="email" data-field="email" data-action="blur->${this.controllerName}#saveInteraction blur->${this.controllerName}#validateEmail focus->${this.controllerName}#removeInvalid">
                            <span class="material-icons lp-input-icon ">email</span>
                            <div data-${this.controllerName}-target="errorEmailCode"></div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 my-2">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="tel" class="form-no-border lp-input-form" placeholder="(XX) X XXXX-XXXX" data-field="uniq_number" data-${this.controllerName}-target="phone" data-action="blur->${this.controllerName}#saveInteraction blur->${this.controllerName}#phoneMask keyup->${this.controllerName}#phoneMask keypress->${this.controllerName}#phoneMask">
                            <span class="material-icons lp-input-icon">phone</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 my-3 d-flex justify-content-between">
                        <div class="form-group form-check d-flex align-items-center mr-3 mb-0">
                          <input type="checkbox" class="form-check-input" name="doctorLanding" data-${this.controllerName}-target="checkboxDoctor" data-kind="doctor" data-action="click->${this.controllerName}#checkKind">
                          <label class="form-check-label ml-1 pointer" for="doctorLanding" style="margin-left:1rem;" data-kind="doctor" data-action="click->${this.controllerName}#checkKind">Médico</label>
                        </div>
                        <div class="form-group form-check d-flex align-items-center mr-3 mb-0">
                          <input type="checkbox" class="form-check-input" name="academicLanding" data-${this.controllerName}-target="checkboxAcademic" data-kind="academic" data-action="click->${this.controllerName}#checkKind">
                          <label class="form-check-label ml-1 pointer" for="academicLanding" style="margin-left:1rem;" data-kind="academic" data-action="click->${this.controllerName}#checkKind">Acadêmico</label>
                        </div>
                        <div class="form-group form-check d-flex align-items-center mr-3 mb-0">
                          <input type="checkbox" class="form-check-input" name="notDoctorLanding" data-${this.controllerName}-target="checkboxNotDoctor" data-kind="not_doctor" data-action="click->${this.controllerName}#checkKind">
                          <label class="form-check-label ml-1 pointer" for="notDoctorLanding" style="margin-left:1rem;" data-kind="not_doctor" data-action="click->${this.controllerName}#checkKind">Outro</label>
                        </div>
                      </div>
                      <div class="col-5 my-1 px-0 d-none mr-auto" data-${this.controllerName}-target="academicRow">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="text" class="form-no-border lp-input-form lp-input-form-w-90" placeholder="Faculdade" data-${this.controllerName}-target="school">
                            <span class="material-icons lp-input-icon">school</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-5 my-1 px-0 d-none mr-auto" data-${this.controllerName}-target="academicRow">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="tel" class="form-no-border lp-input-form lp-input-form-w-90 lp-input-form-pl-10" placeholder="Ano Formatura" data-${this.controllerName}-target="graduation">
                          </div>
                        </div>
                      </div>
                      <div class="col-5 my-1 pr-0 d-none mr-auto" data-${this.controllerName}-target="doctorRow">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="text" class="form-no-border lp-input-form lp-input-form-w-90" placeholder="UF" data-field="crm_state" data-${this.controllerName}-target="crmStateInput" data-action="blur->${this.controllerName}#saveInteraction keyup->${this.controllerName}#upcase">
                            <span class="material-icons lp-input-icon">medication</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-5 my-1 pl-0 d-none" data-${this.controllerName}-target="doctorRow">
                        <div class="forms-group">
                          <div class="floating-label">
                            <input type="tel" class="form-no-border lp-input-form lp-input-form-w-90 lp-input-form-pl-10" placeholder="CRM" data-field="crm" data-${this.controllerName}-target="crmInput" data-action="blur->${this.controllerName}#saveInteraction keyup->${this.controllerName}#upcase">
                          </div>
                        </div>
                      </div>
                      <div class="col-12 d-flex justify-content-between">
                        <div class="forms-group ">
                          <div class="form-check lp-check mt-4">
                            <input type="checkbox" class="form-check-input" name="optInEvent" data-${this.controllerName}-target="optInEvent" data-confirm="false" data-action="click->${this.controllerName}#confirmOptIn">
                            <label class="form-check-label" for="optInEvent" style="margin-left:1rem;"> Eu concordo com os <a class="a-white" href="/termos-de-uso-e-politica-privacidade" target="blank">Termos de Uso e Política de Privacidade</a> e com o <a class="a-white" href="/termos-de-consentimento-de-imagem" target="blank">Termo de Consentimento de Imagem</a></label>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="forms-group">
                          <button disabled type="submit" class="lp-btn-primary" href="#" data-${this.controllerName}-target="confirmBtn" data-action="click->${this.controllerName}#saveAdmission">
                            Confirmar
                          </button>
                        </div>
                      </div>

                      
                      
                      
                      
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.formTarget.innerHTML = html)
    }).then(() => {
      controller.refreshSaveBtn()
      // controller.formCardTarget.style.height = ($(window).height() * 0.5) + "px"
      if (this.application.event.started || !this.application.event.blocked) {
        controller.liveBtnTarget.classList.remove("d-none")
      }
    })
  }

  doFinishedHtml() {
    var html = `<div class="card card-lp-bg-primary lp-card mt-6r" data-${this.controllerName}-target="formCard">
                  <div class="card-body d-flex align-items-center justify-content-center">
                    <div class="row">
                      <div class="col-12 my-4 text-center px-0">
                        <h2 class="lp-card-title">Inscrições Encerradas</h2>
                        <p class="d-none" data-${this.controllerName}-target="liveBtn">Inscrições se encerraram, favor entrar em contato pelo WhatsApp abaixo para acessar o Evento.</p>
                      </div>


                      <div class="col-12">
                        <div class="forms-group">
                          <button type="submit" class="lp-btn-primary" href="#" data-${this.controllerName}-target="contactBtn" data-action="click->${this.controllerName}#contactWhatsApp">
                            Entrar em Contato
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.formTarget.innerHTML = html)
    }).then(() => {
      controller.refreshSaveBtn()
      // controller.formCardTarget.style.height = ($(window).height() * 0.5) + "px"
      if (this.application.event.started || !this.application.event.blocked) {
        controller.liveBtnTarget.classList.remove("d-none")
      }
    })
  }

  contactWhatsApp() {
    var url = `https://api.whatsapp.com/send?phone=5531996421912&text=Olá,%20quero%20me%20inscrever!`
    window.open(url, `_blank`)
  }

  goToLive() {
    var url = this.application.event.live_path
    window.open(url, `_self`)
  }

  checkKind(ev) {
    this.kind = ev.currentTarget.dataset.kind

    if (this.kind == `academic`) {
      this.checkboxAcademicTarget.checked = true
      this.checkboxDoctorTarget.checked = false
      this.checkboxNotDoctorTarget.checked = false

      this.academicRowTargets.forEach(element => {
        element.classList.remove("d-none")
      })
      this.doctorRowTargets.forEach(element => {
        element.classList.add("d-none")
      })

    } else if (this.kind == `doctor`) {
      this.checkboxAcademicTarget.checked = false
      this.checkboxDoctorTarget.checked = true
      this.checkboxNotDoctorTarget.checked = false

      this.academicRowTargets.forEach(element => {
        element.classList.add("d-none")
      })
      this.doctorRowTargets.forEach(element => {
        element.classList.remove("d-none")
      })

    } else if (this.kind == `not_doctor`) {
      this.checkboxAcademicTarget.checked = false
      this.checkboxDoctorTarget.checked = false
      this.checkboxNotDoctorTarget.checked = true

      this.academicRowTargets.forEach(element => {
        element.classList.add("d-none")
      })
      this.doctorRowTargets.forEach(element => {
        element.classList.add("d-none")
      })
    }
  }

  phoneMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToFullPhone(ev)
  }

  validateEmail(ev) {
    if (ev.type == "keyup") {
      var email = ev.currentTarget.value
      if (!email.includes("@") && !email.length > 11) {
        this.toggleBtns(false)
      }
    }
  }

  removeInvalid(ev) {
    this.errorEmailCodeTarget.classList.remove("invalid-warning", "my-1", "py-1", "f-1")
    this.errorEmailCodeTarget.style.zIndex = 0
    this.emailTarget.classList.remove("invalid-field")
    this.errorEmailCodeTarget.innerText = ""
  }

  upcase(ev) {
    var value = ev.currentTarget.value
    ev.currentTarget.value = value.toUpperCase()
  }

  confirmOptIn(ev) {
    this.send_data = { current_visit: {}, opt: {} }

    this.send_data.current_visit.current_visit_id = this.application.current_visit_id
    this.send_data.current_visit.current_visit_token = this.getControllerByIdentifier("app--shared--cookies").getCookie("ahoy_visit")
    this.send_data.current_visit.has_data = true
    this.send_data.opt.id = ""
    this.send_data.opt.opt_in = true
    this.send_data.opt.opt_in_at = new Date()
    this.send_data.opt.name = this.application.event.title
    this.send_data.opt.obj_id = this.application.event.id
    this.send_data.opt.obj_type = "event_entity"
    this.send_data.opt.user_id = this.application.current_visit_id
    this.send_data.opt.user_type = "enrollment_attendee"

    this.saveOptIn()
  }

  saveOptIn() {
    const url = "/users/opts/save"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.canConfirm = true
        if (response.process) {
          controller.optInEventTarget.disabled = true
          controller.optInEventTarget.dataset.confirm = true
        } else {
          // controller.getControllerByIdentifier("commercial--marketing--events--live--meeting").doCheckinHtml()
        }
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  saveInteraction(ev) {
    if (this.application.current_visit_id) {
      this.send_data = { admission: {}, event: {}, current_visit: {} }

      this.send_data.current_visit.id = this.application.current_visit_id
      this.send_data.event.id = this.application.event.id
      this.send_data.admission.first_interaction = this.first_interaction
      this.send_data.admission.field = ev.currentTarget.dataset.field
      this.send_data.admission.value = ev.currentTarget.value

      const url = "/commercial/marketing/events/admissions/save_interaction"
      const init = { method: "PUT", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
      var controller = this
      var element = ev.currentTarget
      fetch(url, init)
        .then(response => response.json())
        .then(response => {
          if (!response.check) {
            element.value = ``
          }
          controller.first_interaction = false
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
        })
        .catch(error => {
          controller.getControllerByIdentifier("app--helpers--console").console(error)
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
        })
    }
  }

  saveAdmission() {
    if (this.canConfirm) {
      this.send_data = { event: {}, attendee: {}, admission: {} }

      var phone = this.phoneTarget.value.trim()

      if (phone.length == 16) {
        var ddd = phone.replace("(", "").replace(")", "").replace(" ", "").replace(" ", "").replace("-", "").slice(0, 2)
        var number = phone.replace("(", "").replace(")", "").replace(" ", "").replace(" ", "").replace("-", "").slice(2, 11)
      } else {
        var ddd = phone.replace("(", "").replace(")", "").replace(" ", "").replace(" ", "").replace("-", "")
        var number = phone.replace("(", "").replace(")", "").replace(" ", "").replace(" ", "").replace("-", "")
      }

      this.searchArray.forEach(element => {
        var utm = element.split("=")

        this.send_data.admission[utm[0]] = utm[1]
      })

      this.send_data.event.id = this.application.event.id
      this.send_data.event.event_token = this.application.event.token

      this.send_data.admission.event_id = this.application.event.id
      this.send_data.admission.event_token = this.application.event.token
      this.send_data.admission.date = new Date()

      this.send_data.attendee.name = this.nameInputTarget.value.trim()
      this.send_data.attendee.email = this.emailTarget.value.trim().toLowerCase()
      this.send_data.attendee.ddd = ddd
      this.send_data.attendee.number = number
      this.send_data.attendee.crm = this.crmInputTarget.value.trim()
      this.send_data.attendee.crm_state = this.crmStateInputTarget.value.trim()
      this.send_data.attendee.crm_input = `${this.crmStateInputTarget.value.trim()} ${this.crmInputTarget.value.trim()}`
      this.send_data.attendee.med_school = this.schoolTarget.value.trim()
      this.send_data.attendee.graduation = this.graduationTarget.value.trim()
      this.send_data.attendee.kind = this.kind

      this.requestSaveAdmission()
    }
  }

  requestSaveAdmission() {
    this.stopRefreshing()
    const url = "/commercial/marketing/events/admissions/save_public"
    const init = { method: "PUT", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.application.event = response.data.cln
          if (controller.application.event.started || !controller.application.event.blocked) {
            window.open(controller.application.event.live_path, `_self`)
          } else {
            window.open(controller.application.event.thank_you_path, `_self`)
          }
        } else {
          // controller.toggleBtns(false)
        }
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getEvent() {
    var data = { event: { slug: this.application.event_token } }
    const url = "/commercial/marketing/events/entities/read_public"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          controller.application.event = response.data.cln
          // if (controller.application.event.finished) {
          //   controller.doFinishedHtml()
          // } else {
          //   controller.doFormHtml()
          // }
          controller.doFormHtml()
          controller.doTitleHtml()
          controller.doSubtitleHtml()
          controller.doMidiaHtml()
          controller.doQuestionsForm()
          // controller.getMeeting()
        } else {
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
        }
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  toggleBtns(value) {
    if (value) {
      this.confirmBtnTarget.disabled = false
      // this.confirmBtnTarget.classList.remove("bg-disabled")
      // this.confirmBtnTarget.classList.remove("none")
      // this.confirmBtnTarget.classList.add("bg-primary")
      // this.confirmBtnTarget.classList.add("pointer")
      // this.canConfirm = true
    } else {
      this.confirmBtnTarget.disabled = true
      // this.confirmBtnTarget.classList.add("bg-disabled")
      // this.confirmBtnTarget.classList.add("none")
      // this.confirmBtnTarget.classList.remove("bg-primary")
      // this.confirmBtnTarget.classList.remove("pointer")
      // this.canConfirm = false
    }
  }

  setNavbarSpacing() {
    var navbarHeight = Number($('#navMobile').height());
    var navbarPadding = Number($('#navMobile').css('padding-top').replace("px", "")) + Number($('#navMobile').css('padding-bottom').replace("px", ""));
    var navbarSpacing = navbarHeight + navbarPadding
    this.navbarSpacingTarget.style.marginTop = navbarSpacing + "px"
    this.doPagePreload()
    this.getEvent()
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.mainTarget.style.height = ($(window).height()) + "px"
    this.mainFrameTarget.style.height = ($(window).height()) + "px"
    this.midiaFrameTarget.style.height = ($(window).height()) + "px"
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshInfoTimer = setInterval(function () {
      var len = 0

      if (controller.hasConfirmBtnTarget) {
        if (controller.nameInputTarget.value == ``) {
          len += 1
        }
        
        if (controller.emailTarget.value == ``) {
          len += 1
        }
        
        if (controller.phoneTarget.value == `` || controller.phoneTarget.length < 16) {
          len += 1
        }
        
        if (controller.optInEventTarget.dataset.confirm == true || controller.optInEventTarget.dataset.confirm == "true") {
          len += 0
        } else {
          len += 1
        }
        
        
        if (len == 0) {
          controller.confirmBtnTarget.disabled = false
        } else {
          controller.confirmBtnTarget.disabled = true
        }
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshInfoTimer) {
      clearInterval(this.refreshInfoTimer)
    }
  }
}